import logo from './images/tb-logo.png';
import footerLogo from './images/tb-footer-gold.png';
import * as theme from './theme';
import { Outlet } from 'react-router';
import React from "react";
import muiTheme from './theme/muiTheme';
import './theme/index.css';
import { ThemeProvider } from '@mui/material';

function PublicFormLayout() {

  return (
    <ThemeProvider theme={muiTheme}>
      <div className="app">
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <img src={logo} alt="TruBalance Bioenergetics" style={{ height: 100 }} />
        </div>
        <main className="content">
          <Outlet />
        </main>
        <footer className="footer">
          <a href="https://trubalancebioenergetics.com">
            <img src={footerLogo} alt="TruBalance Bioenergetics" />
          </a>
        </footer>
      </div>
    </ThemeProvider>
  );
}

export default PublicFormLayout;